export default httpClient => ({
  save: async ({ token, nome, email, password }) => {
    const headers = {
      "Authorization": "Bearer " + token
    }
    const response = await httpClient.post('/usuarios', {
      nome,
      email,
      password,
    }, { headers })

    return {
      data: response.data,
    }
  },
  update: async ({ id, nome, email, password, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.patch('/usuarios/' + id, {
      id,
      nome,
      email,
      password
    }, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/usuarios/' + id, { headers });
    return {
      data: response.data
    }
  },
  getInfos: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/infos-sistema', { headers });
    return {
      data: response.data
    }
  },
  ip: async () => {
    const response = await httpClient.post('/acesso', {
    });
    return { data: response.data }
  },
  getAll: async ({ token }) => {
    const headers = {
      "Authorization": "Bearer " + token
    }
    const response = await httpClient.get('/usuarios', { headers });
    return { data: response.data }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/usuarios/' + id, { headers });
    return {
      data: response
    }
  },
  email: async ({ nome, email, assunto, }) => {
    const response = await httpClient.post('/contato', {
      nome,
      email,
      assunto,
    });
    return { data: response.data }
  },

});